import {usePlayers} from '@glark-newco/game-library';
import {ChatAndPlayerListPanel} from './ChatAndPlayerListPanel';
import {GameRulesButton} from './GameRulesPanel';
import {LinkConsentModal} from './LinkConsentModal';
import {ReviewStatsButton} from './ReviewStatsButton';
import {StartGameTimerButton} from './StartGameTimerButton';
import {useIsGameStarted} from '../state/GameTimerSlice';

function FacilitatorActions() {
    const gameTimerStarted = useIsGameStarted();

    if (!gameTimerStarted)
        return <StartGameTimerButton/>;

    else
        return <ReviewStatsButton/>;
}

export function GamePlayOverlay() {
    const {localPlayer} = usePlayers();

    return (
        <>
            {localPlayer.isFacilitator && <>
                <FacilitatorActions/>
                <LinkConsentModal />
            </>}
            <GameRulesButton />
            <ChatAndPlayerListPanel />
        </>
    );
}
